export const MASTER_APP_TOKEN = "sSzGgFdJBW2x6tkwxlRErBfLuDmjXYqd";
export const GA_DEBUG = true;
// export const API_PREFIX = ( FN_MODE === "qa" ? "http://api.zoomauth.local/api/v1/" :"https://api.zoomauth.com/api/v1/" );
export const API_PREFIX = ( FN_MODE === "qa" ? "https://qa.zoomauth.com/api/v1/" :"https://api.zoomauth.com/api/v1/" );
export const STORAGE_PREFIX = "zoom_sdk_";
import zoom_icon from "resources/img/FaceTec-logo-highres.png";
export const ZOOM_ICON = zoom_icon;
export const LOGGLY_KEY = "98508576-85af-467e-8713-9ae93891800c";
export const BROWSER_SITE_URL = ( FN_MODE === "qa" ? "https://qabrowser.zoomlogin.com/" :"https://browser.zoomlogin.com/" );
export const BOUNTY_SITE_URL = ( FN_MODE === "qa" ? "https://qabounty.zoomlogin.com/" :"http://bounty.zoomlogin.com/" );

if (!window.location.origin) {
  window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":" + window.location.port: "");
}



// WEBPACK FOOTER //
// ./src/js/config.jsx